<!--赖传峰-->
<!--2023/4/6-->
<template>
  <header
    v-if="visible"
    class="header"
  >
    <div class="header-left">
      <a
        class="open-sidebar"
        @click="layoutStore.sidebarMobileVisible = true"
      />
      <a
        :href="RoutePathOfDrive.ALL"
        class="logo"
      />
    </div>
    <div class="login-entry-placeholder">
      <ClientOnly>
        <OpenAppButton>
          <template
            #default="slotProps"
          >
            <PPButton
              :loading="slotProps.loading"
              class="open-app"
              height="36px"
              type="primary"
              @click="slotProps.handleOpenApp"
            >
              {{ $t('open-app') }}
            </PPButton>
          </template>
        </OpenAppButton>
      </ClientOnly>
    </div>
  </header>
</template>

<script
  lang="ts"
  setup
>

import {
  computed,
  isPikPakClient,
} from '#imports'
import OpenAppButton from '@/components/share/OpenAppButton.vue'
import { useLayout } from '~/store/layout'
import {
  RoutePathOfDrive,
} from '~/types/enum'

const layoutStore = useLayout()
const visible = computed(() => !isPikPakClient())
</script>

<style
  lang="less"
  scoped
>
@import 'driveHeader.style';
</style>
